export default __webpack_public_path__ + "static/trophy-fdda6d8febcd759a94c446ad38b831d2.png";